import { useEffect, useState } from "react";
import styled from "styled-components";
import { gnbConst } from "../constants/gnbConst";
import { CommmonBoxLayout, CommonBoxTitle, CommonLayout, FlexColBetweenBox, LinkTd, MailYesNoTd, SearchBox, TableLayout } from "../style/common";
import Search from "../components/common/Search";
import { flex, flexBetween, flexUnsetCenter } from "../style/mixins";
import Input from "../components/common/Input";
import useFormattedDate from "../hooks/useFormattedDate";
import PdfBtn from "../components/common/pdfBtn";
import { theme } from "../theme";
import Mp3Btn from "../components/common/mp3Btn";
import Table from "../components/common/Table";
import { materialTheadArr } from "../constants/TheadConst";
import { useNavigatePage } from "../hooks/useNavigatePage";
import { contentsList } from "../api/contents";
import { Spinner } from "../components/common/Spinner";
import { dateHyphen } from "../utils/dateFormChange";
import { stringToJson } from "../utils/stringToJson";
import { mailSendText } from "../utils/mailSendText";
import { isFilePath } from "../utils/isFilePath";
import Paging from "../components/common/paging";

export default function Material() {
  const { onMovementPage } = useNavigatePage();
  const pageTitle = gnbConst[5].title;
  const [searchVal, setSearchVal] = useState("");
  const [startDate, setStartDate] = useState(useFormattedDate({ monthNum: -1 }));
  const [endDate, setEndDate] = useState(useFormattedDate({}));
  const [pagingVal, setPagingVal] = useState(1);
  const [noticeListData, setNoticeListData] = useState<ListGetApiResponse>();

  const onClickGoDetail = (idx: string) => {
    onMovementPage("/material/detail/" + idx);
  };

  const onPageChange = (page: number) => {
    setPagingVal(page);
  };

  const getMaterialList = async () => {
    try {
      const params = {
        page_index: pagingVal,
        page_size: 10,
        search_field: "member_name, member_id, extras, title",
        search: searchVal,
        tags: "",
        create_date_start: startDate + " 00:00:00",
        create_date_end: endDate + " 23:59:59",
        task_load: 1,
      }

      if (searchVal.trim().length > 0) {
        params.tags = `${searchVal}:*`;
      }

      const respones = await contentsList(params, "material");
      setNoticeListData(respones);
    } catch (error) { }
  }

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const {
      target: { name, value },
    } = e;

    if (name === "search") {
      setSearchVal(value);
    } else if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    }
  };

  useEffect(() => {
    if (searchVal || startDate || endDate) setPagingVal(1);
    getMaterialList();
  }, [searchVal, startDate, endDate]);

  useEffect(() => {
    getMaterialList();
  }, [pagingVal]);

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <FlexColBetweenBox>
          <div>
            <BoxtitleCustom>
              {pageTitle}
              {noticeListData && (<p>( {noticeListData.page?.total ? noticeListData.page.total : 0} )</p>)}
            </BoxtitleCustom>

            <SearchBoxCustom>
              <DataSearchBox>
                <DataSearch>
                  <Input
                    type="date"
                    name="startDate"
                    width="9.75rem"
                    height="2.25rem"
                    value={startDate}
                    onChange={onSearchChange}
                  />
                  ~
                  <Input
                    type="date"
                    name="endDate"
                    width="9.75rem"
                    height="2.25rem"
                    value={endDate}
                    onChange={onSearchChange}
                  />
                </DataSearch>
                <Search value={searchVal} onChange={onSearchChange} placeholder="전체검색" />
              </DataSearchBox>
              {/* <DownLoadBtns /> */}
            </SearchBoxCustom>
            {noticeListData ? (
              <TableLayout>
                <Table thead={materialTheadArr}>
                  {noticeListData.list.map(obj => {
                    const mailTask = obj.task?.find(t => t.task_idx === process.env.REACT_APP_MAIL_TASK_IDX);
                    return (
                    <tr key={obj.idx}>
                      {/* <td><input type="checkbox" /></td> */}
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.date_active ? dateHyphen(obj.date_active, "YYYY-MM-DD") : "-"}</LinkTd>
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.member?.member_id ? obj.member.member_id : "-"}</LinkTd>
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.member?.member_name ? obj.member.member_name : "-"}</LinkTd>
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>
                        {obj.member?.member_public_extras ? stringToJson(obj.member.member_public_extras).com : "-"}
                      </LinkTd>
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>
                        {obj.member?.member_public_extras ? stringToJson(obj.member.member_public_extras).sub : "-"}
                      </LinkTd>
                      <LinkTd onClick={() => onClickGoDetail(obj.idx)}>{obj.title}</LinkTd>
                      <td>
                        {obj.files && obj.files.length > 0 ? (
                          isFilePath(obj.files, "pdf").length > 0 ? (
                            <PdfBtn
                              path={isFilePath(obj.files, "pdf")[0].file_url as string}
                              fileName={isFilePath(obj.files, "pdf")[0].file_name_origin as string}
                            />
                          ) : "-"
                        ) : "-"}
                      </td>
                      <td>
                        {obj.files && obj.files.length > 0 ? (
                          isFilePath(obj.files, "m4a").length > 0 ? (
                            <Mp3Btn
                              path={isFilePath(obj.files, "m4a")[0].file_url as string}
                              fileName={isFilePath(obj.files, "m4a")[0].file_name_origin as string}
                            />
                          ) : "-"
                        ) : "-"}
                      </td>
                      <MailYesNoTd
                        $mail={mailTask?.task_state ?? undefined}>
                        {mailTask ? mailSendText(mailTask.task_state as number) : "실패"}
                      </MailYesNoTd>
                    </tr>
                    );
                  })}
                </Table>
                <Paging
                  pageIndex={pagingVal}
                  totalPage={noticeListData.page?.total_page ? noticeListData.page.total_page : 0}
                  onPageChange={onPageChange}
                />
              </TableLayout>
            ) : <Spinner />}
          </div>
        </FlexColBetweenBox>
      </CommmonBoxLayout>
    </CommonLayout>
  );
}

const BoxtitleCustom = styled(CommonBoxTitle)`
  ${flex};
  gap: 0.375rem;

  > p {
    color: ${theme.color.mp3};
    font-weight: 400;
  }
`;

const SearchBoxCustom = styled(SearchBox)`
  ${flexBetween};
`;

const DataSearchBox = styled.div`
  ${flex};
  gap: 1.875rem;
`;

const DataSearch = styled.div`
  color: #6C757D;
  font-size: 0.875rem;
  font-weight: 600;
  ${flexUnsetCenter};
  gap: 0.625rem;
`;